import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";
import { Marquee } from "../components/Marquee";
import { PILLARS, PROCESS, IMG } from "../data/content";

export default function About() {
  return (
    <main>
      <PageHero
        eyebrow="About Mega"
        title="We Create the Moment Around the Occasion"
        description="Mega Celebrity Events brings together creativity, entertainment, production, hospitality and execution to support distinctive events across Andhra Pradesh and Telangana."
        image={IMG.dinnerEvent}
      />

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.35em] text-[#C9A55C]">Brand Vision</p>
            <p className="mt-4 font-accent italic text-2xl text-[#F3EEE5]/90 leading-relaxed">
              “A premium entertainment and event experience house that transforms an occasion into a memorable public moment.”
            </p>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-8">
            <p className="text-[#A9ABB2] leading-relaxed text-sm sm:text-base max-w-2xl">
              Based in Vijayawada, we work at the intersection of celebrity coordination, cinematic production and five-star hospitality. Every engagement — a wedding, a launch, a concert, a public programme — is treated as a production with an audience, a narrative and a moment it must deliver.
            </p>
            <p className="mt-6 text-[#A9ABB2] leading-relaxed text-sm sm:text-base max-w-2xl">
              Our philosophy is simple: imagination sets the direction, production builds the stage, hospitality carries the guests, and execution earns the applause.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee />

      <section className="py-20 lg:py-28 bg-[#0D1018] border-y border-[#C9A55C]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <SectionHead eyebrow="The Mega Signature" title="What Makes an Event Feel Mega?" />
          <div className="mt-12 divide-y divide-[#C9A55C]/12 border-y border-[#C9A55C]/12">
            {PILLARS.map((p) => (
              <Reveal key={p.num}>
                <div className="grid sm:grid-cols-12 gap-4 items-baseline py-7 px-2">
                  <span className="sm:col-span-2 font-accent italic text-2xl text-[#C9A55C]/70">{p.num}</span>
                  <h3 className="sm:col-span-4 font-display text-xl sm:text-2xl text-[#F3EEE5] uppercase tracking-wide">{p.title}</h3>
                  <p className="sm:col-span-6 text-sm text-[#A9ABB2] leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <SectionHead eyebrow="Our Process" title="From First Conversation to Final Applause" />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C9A55C]/12 border border-[#C9A55C]/12">
            {PROCESS.map((s) => (
              <Reveal key={s.num}>
                <div className="bg-[#070708] p-8 h-full">
                  <p className="font-accent italic text-3xl text-[#C9A55C]/60">{s.num}</p>
                  <h3 className="font-display text-xl text-[#F3EEE5] mt-4 uppercase tracking-wide">{s.title}</h3>
                  <p className="mt-3 text-sm text-[#A9ABB2] leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <Link to="/plan-your-event" className="btn-gold mt-12 inline-flex" data-testid="about-cta-btn">Create Your Event</Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
